<template>
  <div class="subject-box">
    <div class="bread-bar">{{ $t("话题分类") }}</div>

    <div class="subject-classly df">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item, index) in subjectList" :key="item.id">
          <div class="list df aic" :class="{ active: index == subjectIndex }" :key="index"
            @click="changeSubject($event, index)">
            <el-image style="width: 66px; height: auto" :src="getBackgroundStyle(item, index)" fit="fill"
              class="log-imgs">
              <div slot="error" class="image-slot">
                <!-- <img src="@/assets/images/avatar.png" alt=""> -->
              </div>
            </el-image>
            <span class="s1 f1">{{ item.tt_title }}</span>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <!-- 详情 -->
    <div class="subject-desc">
      <div class="desc-box">
        <div class="descbox">
          <div class="title mic-semblod">{{ subjectDesc.tt_title }}</div>
          <div class="desc" v-html="subjectDesc.tt_content"></div>
        </div>
      </div>
    </div>

    <!-- 话题文章 -->
    <div class="topic-article df">
      <!-- 话题文章列表 -->
      <div class="article-list">
        <div class="head-box df aic jcsb">
          <div>
            <span class="s1 active">{{ $t("话题文章") }}</span>
            <span class="s1">{{ $t("专家互动") }}</span>
          </div>
          <div class="df aic">
            <!-- 选择 -->
            <div>
<!--              <el-radio v-model="searchForm.sort_method" :label="0" @change="changeSortMethod(0)">{{ $t("最热") }}</el-radio>-->
<!--              <el-radio v-model="searchForm.sort_method" :label="10" @change="changeSortMethod(10)">{{ $t("最新") }}</el-radio>-->
              <el-radio v-model="searchForm.sort_method" :label="0" @change="changeSortMethod(0)">{{$t("全部") }}</el-radio>
              <el-radio v-model="searchForm.sort_method" :label="10" @change="changeSortMethod(10)">{{$t("最新") }}</el-radio>
              <el-radio v-model="searchForm.sort_method" :label="20" @change="changeSortMethod(20)">{{$t("最热") }}</el-radio>
              <el-radio v-model="searchForm.sort_method" :label="30" @change="changeSortMethod(30)">{{$t("精华") }}</el-radio>
            </div>
            <!-- 文章投稿 -->
            <el-button class="post-article" @click="handelOpenarticle(thumbsId)">{{ $t("文章投稿") }}</el-button>
          </div>
        </div>

        <div class="article-box">
          <div class="list-box" v-loading="listLoading">
            <div class="list"
              v-for="(items, indexs) in topic_article_list" :key="indexs"
              @click="$navigate('/subject/info', items.ttar_id)">
              <div class="t1s df jcsb aic over-h">
                <div class="mic-semblod one-text">
                  <!-- <span class="essence" v-if="[1, 0, 2].includes(indexs) && pagination.page == 1">{{ $t("精") }}</span> -->
                  <span class="essence" v-if="items.ttar_rec==900">{{ $t("精1") }}</span>
                  <!-- 暂时不显示热 -->
                  <!-- <span class="hot">{{ $t("热") }}</span> -->
                  <span class="hot" style="background-color: #fdb906ff" v-if="items.ttar_rec==1000">{{
                    $t("顶1")
                  }}</span>
                  {{ items.ttar_title }}
                </div>
                <!-- <div class="show-box fn">
                                    <img  src="@/assets/images/hot.png" alt="" />
                                    <img src="@/assets/images/essence.png" alt="" />
                                </div> -->

              </div>
              <div class="desc tow-text" :title="items.ttar_desc">
                {{ items.ttar_desc }}
              </div>

              <div class="userinfo-box df jcsb aic over-h">
                <div class="users df aic f1 over-h">
                  <div @click="(event) => handleaAvatar(event, items)" class="df">
                    <template v-if="items.ttar_type == 10">
                      <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn" @error="handleImageError">
                        <img src="@/assets/images/avatar.png" alt="" />
                      </el-avatar>
                    </template>
                    <template v-else>
                      <el-avatar :size="18" :src="require('@/assets/images/avatar.png')" class="fn"></el-avatar>
                    </template>
                  </div>
                  <span class="name fn">
                    {{
                      items.is_expert == 10
                        ? items.user_name
                        : items.ttar_type == 20 ||
                          items.user_id == 0 ||
                          items.user_nick_name === "" ||
                          items.user_nick_name === null
                          ? $t("匿名用户")
                          : items.user_nick_name
                    }}
                  </span>

                  <div class="f1 type one-text" v-if="items.user_excel_arr.length">
                    <span v-for="items1 in items.user_excel_arr" :key="items1.label">{{ items1.label }}</span>
                  </div>
                </div>

                <div class="dates df fn">
                  <div class="comment-list df">
                    <div class="li">
                      <span class="iconfont">&#xe611;</span>
                      <span class="text">{{ items.ttar_hits }}</span>
                    </div>
                    <div class="li">
                      <span class="iconfont">&#xe61b;</span>
                      <span class="text">{{ items.ttar_likes }}</span>
                    </div>
                    <div class="li">
                      <span class="iconfont">&#xe63e;</span>
                      <span class="text">{{ items.reply_count }}</span>
                    </div>
                  </div>
                  <span class="date">{{ items.create_time }}</span>
                </div>
              </div>
            </div>

            <div class="pager-box df jcc">
              <el-pagination :total="pagination.total" :current-page="pagination.page" :page-size="10"
                layout="prev,slot, next" @current-change="handleCurrentChange">
                <template><span class="page-slot">{{ pagination.page }}/{{ pagination.last_page }}</span></template>
              </el-pagination>
            </div>

            <div class="no-data pt-86" v-if="topic_article_list.length == 0">
              <img src="@/assets/images/empty_data.png" alt="" />
              <p>{{ $t("暂无数据") }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 主持人专区 -->
      <div class="host-zone">
        <div class="head-box">
          <span class="s1">{{ $t("主持人") }}</span>
        </div>

        <div class="zone-box">
          <div class="host-list">
            <swiper :options="swiperOption">
              <swiper-slide v-for="(item, index) in topic_host_list" :key="item.tth_id">
                <div class="list">
                  <div class="head-list df aic jcsb">
                    <div class="df aic">
                      <div @click="(event) => handleaAvatar(event, item)" class="cup">
                        <el-avatar :size="48" :src="item.user_avatar_url">
                          <img src="@/assets/images/avatar.png" alt="" />
                        </el-avatar>
                      </div>
                      <div class="ml-16">
                        <div class="name">{{ item.user_nick_name }}</div>
                        <div class="fans">
                          {{ $t("粉丝")
                          }}<span>{{ item.user_fans_count }}</span>
                        </div>
                      </div>
                    </div>
                    <el-button class="hred-btn fn" @click="handleFollow(item.user_id)" :loading="followLoading">
                      <span class="iconfont fs-10">{{
                        item.have_be_follow == 1 ? "&#xebe6;" : "&#xe623;"
                      }}</span>
                      {{
                        item.have_be_follow == 1 ? $t("已关注") : $t("关注")
                      }}</el-button>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <!-- 主持人专区 -->
          <div class="zone-list df aic jcsb" @click="handlePostZone()" v-if="topic_article_is_host">
            <div class="c1 df aic">
              {{ $t("进入主持人专区") }}<span class="iconfont">&#xe605;</span>
            </div>
            <span class="c2">{{ $t("待审核") }}：{{ topic_article_dealt_num }}</span>
          </div>
        </div>

        <!-- 专家：先不做 -->
        <!-- <div class="head-box mt-32">
          <span class="s1">{{ $t("专家") }}</span>
        </div>
        <div class="expert-box">
          <div class="host-list">
            <div class="list">
              <div class="head-list df aic jcsb">
                <div class="df aic">
                  <el-avatar
                    :size="48"
                    :src="require('@/assets/images/avatar.png')"
                  ></el-avatar>
                  <div class="ml-16">
                    <div class="name">Nina</div>
                    <div class="fans">{{ $t("粉丝") }}<span>23</span></div>
                  </div>
                </div>
                <el-button class="hred-btn">+{{ $t("关注") }}</el-button>
              </div>
              <div class="expert-list df aic">
                <div class="f1">
                  <p class="p1">{{ $t("文章") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("帖子") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("评论") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("提问") }}</p>
                  <p class="p2">3</p>
                </div>
              </div>
            </div>

            <div class="list">
              <div class="head-list df aic jcsb">
                <div class="df aic">
                  <el-avatar
                    :size="48"
                    :src="require('@/assets/images/avatar.png')"
                  ></el-avatar>
                  <div class="ml-16">
                    <div class="name">Nina</div>
                    <div class="fans">粉丝<span>23</span></div>
                  </div>
                </div>
                <el-button class="hred-btn">+关注</el-button>
              </div>
              <div class="expert-list df aic">
                <div class="f1">
                  <p class="p1">{{ $t("文章") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("帖子") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("评论") }}</p>
                  <p class="p2">3</p>
                </div>
                <div class="f1">
                  <p class="p1">{{ $t("提问") }}</p>
                  <p class="p2">3</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 相关活动 -->
    <div class="related-activity">
      <div class="title df aic jcsb">
        <span>{{ $t("相关活动") }}</span>
        <!-- thumbsId -->
        <el-button type="text" class="btn df aic" @click="$navigate('/subject/activeList', searchForm.tt_id)">{{
          $t("更多")
          }}<span class="iconfont">&#xe79a;</span></el-button>
      </div>

      <div class="activity-box df fww">
        <div class="no-data pt-86" v-if="hot_act_list.length == 0">
          <img src="@/assets/images/empty_data.png" alt="" />
          <p>{{ $t("暂无数据") }}</p>
        </div>

        <div class="list" v-for="item in hot_act_list" :key="item.ta_id" @click="$navigate((item.ta_kind==30?'/challenge/info':'/activity/info'), item.ta_id)">
          <div class="imgs">
            <el-image :src="item.ta_thumb">
              <img slot="error" src="@/assets/images/news-default.png" alt="" />
            </el-image>
            <!-- <img :src="item.ta_thumb" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="t1s one-text mic-semblod">
              {{ item.ta_title }}
            </div>
            <div class="de1 one-text">{{ item.ta_desc }}</div>
            <div class="address df aic jcsb">
              <div class="l1">
                <div>
                  <span class="iconfont">&#xe61f;</span><span class="t1">{{ item.ta_city_text }}</span>
                </div>
                <div>
                  <span class="iconfont">&#xe602;</span><span class="t1">
                    {{ item.ta_start_time }}
                  </span>
                </div>
              </div>

              <el-button class="btn end" v-if="item.is_sign_up == 10">
                {{ $t("活动已结束") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 20">
                {{ $t("即将举行") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 30">
                {{ $t("活动报名中") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 40">
                {{ $t("活动进行中") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 文章投稿 -->
    <articleModel ref="articleDialog" :tt_id="thumbsId" :classData="tablist" :articleScore="article_score" @post-submitted="handlePostSubmitted" />

    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handlePublisherFollow" :id="id"
      :publisherFollowLoading="publisherFollowLoading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { setArticleAdd } from "@api/active";
// 文章投稿
import articleModel from "@/components/articleModel.vue";
import {getcommonData, setuserfollowAdd, userDataLv2} from "@api/home";
// 接口
import {
  getTopicList,
  getTopicArticleList,
  getTopicArticleInfo,
  getTopicHostList,
} from "@api/subject";

export default {
  components: { Swiper, SwiperSlide, articleModel },
  data() {
    return {
      id: 0, //发布者 弹窗的 用户ID
      // swiper参数设置
      swiperOption: {
        spaceBetween: 14,
        slidesPerView: "auto",
        normalizeSlideIndex: false,
        watchSlidesVisibility: true /*避免出现bug*/,
      },

      //文章列表 loading
      listLoading: false,
      //关注 主持人loading
      followLoading: false,
      //发布者关注loading
      publisherFollowLoading: false,
      // 话题分类列表
      subjectList: [],
      article_score: [],

      // 话题分类默认选择  对应话题分类id
      subjectIndex: 1,
      subjectDesc: "",
      topic_article_list: [], //话题文章列表
      topic_host_list: [], //话题主持人列表
      hot_act_list: [], //话题活动列表
      topic_article_is_host: false, // 是否是主持人
      topic_article_dealt_num: 0, // 待办数量

      thisUserInfo: [], //当前登录人信息
      // 分页
      pagination: {
        page: 1,
        total: 10,
        last_page: 1,
      },

      // 话题文章筛选
      searchForm: {
        sort_method: 0,
      },

      // 主持人专区swiper 参数
      hotswiperOption: {
        slidesPerView: 1,
        normalizeSlideIndex: false,
        watchSlidesVisibility: true /*避免出现bug*/,
      },

      // 文章投稿
      thumbsId: 0, //话题分类id
      tablist: [],
    };
  },
  computed: {},
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit("changeNavbg", "rgba(255, 255, 255, 1);");
    // 获取初始化数据
    this.getData();

    // this.getCurrUserData();
  },
  methods: {
    // 背景返回
    getBackgroundStyle(item, index) {
      // 根据当前索引返回不同的背景图
      const activeBackground = item.tt_thumb_chose_url; //选中图

      const inactiveBackground = item.tt_thumb_no_chose_url; // 默认图

      return `${index === this.subjectIndex ? activeBackground : inactiveBackground
        }`;
    },
    // 初始化数据
    async getData() {
      const res = await getTopicList();
      this.subjectList = res.data.topic_list;
      this.tablist = this.subjectList;

      if (!this.searchForm.tt_id) {
        // 默认选择第一个
        this.subjectIndex = 0;
        this.subjectDesc = this.subjectList[0];

        this.searchForm.tt_id = this.subjectList[0].tt_id;
      }

      this.thumbsId = parseInt(this.searchForm.tt_id);

      this.getArticleListData();
      this.getArticleHostData();
    },
    // 获取话题 文章列表
    async getArticleListData() {
      this.listLoading = true;
      const resList = await getTopicArticleList({
        ...this.searchForm,
        page: this.pagination.page,
      });

      this.thumbsId = parseInt(this.searchForm.tt_id);

      if (resList.status == 200) {
        this.pagination.total = resList.data.topic_article_list.total;
        this.topic_article_list = resList.data.topic_article_list.data;
        this.pagination.last_page = resList.data.topic_article_list.last_page;

        this.hot_act_list = resList.data.hot_act_list;
      }
      this.listLoading = false;
    },

    // 获取话题主持人列表
    async getArticleHostData() {
      const resList = await getTopicHostList({
        tt_id: this.searchForm.tt_id,
      });
      if (resList.status == 200) {
        this.topic_host_list = resList.data.topic_host_list;
        this.topic_article_is_host = resList.data.topic_article_is_host;
        this.topic_article_dealt_num = resList.data.topic_article_dealt_num;
      }
    },

    // 切换话题分类
    changeSubject(event, index) {
      this.subjectIndex = index;
      this.subjectDesc = this.subjectList[index];
      this.searchForm.tt_id = this.subjectDesc.tt_id;
      this.pagination.page = 1;
      this.getArticleListData();
      this.getArticleHostData();
    },
    // 切换排序方式
    changeSortMethod(val) {
      this.searchForm.sort_method = val;
      this.pagination.page = 1;
      this.getArticleListData();
    },

    // 关注主持人
    async handleFollow(id) {
      this.followLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getArticleHostData();
      }
      setTimeout(() => {
        this.followLoading = false;
      }, 1000);
    },

    // 关注 发布者
    async handlePublisherFollow(id) {
      this.publisherFollowLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
      setTimeout(() => {
        this.publisherFollowLoading = false;
      }, 1000);
    },

    // 跳转主持人专区
    handlePostZone() {
      let str = "/cn";
      let Language = localStorage.getItem("currentLanguage"); //获取本地语言
      if (Language && Language != "zh") {
        str = "/" + Language;
      }
      const target = this.$router.resolve(str + "/subject/hostZone");
      window.open(target.href, "_blank");
    },

    // 头像加载失败
    handleImageError() {
      return true;
    },

    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getData();
    },

    // 头像显示个人信息

    handleaAvatar(event, item) {
      // 判断是否是实名用户
      if (
        item.ttar_type == 20 ||
        item.user_id == 0 ||
        item.user_nick_name == "" ||
        item.user_nick_name == null
      ) {
        return false;
      }
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();
      console.log(212121212121);
      console.log(item);

      this.id = item.user_id;
      console.log(this.id);
    },

    // 文章投稿
    async handelOpenarticle(id) {
      let checkRes=await userDataLv2();
      if(checkRes.status!=200){
          return false;
      }
      this.thumbsId = id;
      // 没有登录信息，跳转到登录
      this.thisUserInfo = JSON.parse(localStorage.getItem("userinfo"));
      if (
        this.thisUserInfo.user_id === undefined ||
        this.thisUserInfo.user_id < 1
      ) {
        this.$jumpLogin();
        return false;
      }
      let article_score = localStorage.getItem('datalist');
      if (article_score) {
        this.article_score = JSON.parse(article_score).article_source_list;
      }else {
        let res = await getcommonData();
        if (res.status == 200) {
          this.article_score = res.data.article_source_list;
          localStorage.setItem('datalist',JSON.stringify(res.data));
        }
      }
      setTimeout(() => {
        this.$refs.articleDialog.openModal();
      }, 20);
    },

    // 发布文章
    async handlePostSubmitted(content) {
      content.other_lang[0] = content.other_lang[0] ? 2 : 0;
      content.other_lang[1] = content.other_lang[1] ? 3 : 0;

      let res = await setArticleAdd(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-box {
  margin-top: 29px;
  margin-bottom: 125px;

  .list {
    width: calc(33.33% - 10.7px);
    border-radius: 6px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-right: 16px;
    cursor: pointer;

    &:hover {
      .t1s {
        color: #b7251e;
      }

      ::v-deep() {
        img {
          transform: scale(1.1);
        }
      }
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    .de1 {
      color: rgb(89, 89, 89);
      font-size: 14px;
      height: 22px;
      line-height: 22px;
      margin-top: 8px;
    }

    .t1s {
      color: rgb(25, 25, 25);
      font-size: 18px;
      line-height: 28px;
    }

    .text-box {
      padding: 16px;

      .address {
        .l1 {
          .iconfont {
            font-size: 12px;
            color: #595959;
          }

          .t1 {
            font-size: 12px;
            color: rgb(89, 89, 89);
            line-height: 18px;
            margin-left: 4px;
          }
        }

        .btn {
          min-width: 96px;
          height: 36px;
          line-height: 34px;
          padding: 0 16px;
          border-radius: 20px;
          text-align: center;
          background: rgb(231, 239, 255);
          color: rgb(24, 114, 253);
          font-size: 12px;
          border: none;

          &.end {
            color: #6d7177;
            background: #fff;
            border: 1px solid #6d7177;
          }
        }
      }
    }

    .imgs {
      width: 100%;
      padding-bottom: 52.6%;
      position: relative;
      overflow: hidden;

      ::v-deep() {
        .el-image {
          position: absolute;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          left: 0;
          top: 0;
          transition: all 1s;
        }
      }
    }
  }
}

.related-activity {
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 28px;

  .title {
    color: rgb(25, 25, 25);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 23px;
    font-weight: 400;
    line-height: 36px;
  }

  .btn {
    font-size: 14px;
    color: #a6adb8;

    &:hover {
      color: #b7251e;
    }

    .iconfont {
      font-size: 14px;
      margin-left: 6px;
    }
  }
}

.expert-box {
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgb(255, 255, 255);
  padding: 24px 26px;
  margin-top: 20px;

  .host-list .list {
    margin-bottom: 16px;
  }

  .expert-list {
    height: 62px;
    border-radius: 8px;
    background: rgba(25, 25, 25, 0.02);
    text-align: center;
    margin-top: 12px;

    .p1 {
      color: rgb(89, 89, 89);

      font-size: 12px;
      font-weight: 400;
      line-height: 23px;
    }

    .p2 {
      color: rgb(25, 25, 25);

      font-size: 12px;
      font-weight: 400;
      line-height: 23px;
    }
  }
}

.host-list .list {
  .hred-btn {
    min-width: 65px;
    height: 28px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 20px;
  }

  .name {
    color: rgb(25, 25, 25);
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
  }

  .fans {
    color: rgb(68, 68, 68);
    font-size: 12px;
    font-weight: 400;
    line-height: 23px;

    span {
      display: inline-block;
      margin-left: 20px;
    }
  }
}

.host-zone {
  .zone-box {
    margin-top: 26px;
    // height: 140px;
    border-radius: 12px;
    background: #fdf0f0;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.06);

    .host-list {
      height: 94px;
      border-radius: 12px;
      background: #ffffff;

      .list {
        padding: 24px 26px;
      }
    }

    .head-list {
      height: 48px;
    }

    .zone-list {
      padding: 0 20px;
      height: 42px;

      .c1 {
        color: rgb(188, 13, 16);
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        cursor: pointer;

        .iconfont {
          font-size: 6px;
          margin-left: 5px;
        }
      }

      .c2 {
        font-size: 12px;
        font-weight: 400;
        color: #191919;
        line-height: 22px;
      }
    }
  }

  .head-box {
    height: 32px;

    .s1 {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 22px;
      font-weight: 400;
      line-height: 32px;
    }
  }
}

.subject-box {
  padding: 20px 80px 0;
  margin-top: 60px;

  .topic-article {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 40px;

    .pager-box {
      margin-top: 12px;
    }

    ::v-deep() {

      .el-pagination .btn-next,
      .el-pagination .btn-prev {
        width: 28px;
        height: 28px;
        border-radius: 8px;
        padding: 0;
        min-width: 28px;
        margin-right: 8px;
        margin-left: 8px;

        &:hover {
          background: rgb(255, 243, 242);
        }
      }
    }

    .page-slot {
      color: rgb(25, 25, 25);
      font-size: 14px;
      font-weight: 400;
      line-height: 28px;
      letter-spacing: 2px;
    }

    .list-box {

      .hot-box,
      .essence-box {
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 400px;
          height: calc(100% + 1px);
          opacity: 0.6;
          position: absolute;
          right: -32px;
          top: 0;
        }
      }

      .essence-box {
        &::after {
          background: linear-gradient(-64.32deg,
              rgba(254, 190, 8, 0.21) -2.449%,
              rgba(196, 196, 196, 0) 96.756%);
        }
      }

      .hot-box {
        &::after {
          background: linear-gradient(-64.32deg,
              rgba(255, 0, 0, 0.11) -2.446%,
              rgba(196, 196, 196, 0) 96.716%);
        }
      }

      .list {
        padding: 16px 0 16px;
        border-bottom: 1px solid rgb(243, 243, 243);
        cursor: pointer;
        transition: border-bottom 0.36s;
        z-index: 10;

        &:hover {
          border-bottom: 1px solid #b7251e;

          .t1s {
            color: #b7251e;
          }
        }

        &:last-child {
          border-bottom: none;
        }

        .t1s {
          color: rgb(25, 25, 25);
          font-size: 18px;
          font-weight: 400;
          line-height: 24px;
          padding: 2px 0;

          .essence,
          .hot {
            display: inline-block;
            min-width: 18px;
            height: 18px;
            border-radius: 2px;
            font-size: 14px;
            color: #ffffff;
            line-height: 18px;
            text-align: center;
            margin-right: 4px;
            position: relative;
            padding: 0 2px;
            top: -1px;
          }

          .essence {
            background: rgb(215, 17, 17);
          }

          .hot {
            background: rgb(255, 110, 0);
          }

          .show-box {
            img {
              margin-left: 6px;
            }
          }
        }

        .desc {
          color: rgb(51, 51, 51);
          font-size: 14px;
          font-weight: 400;
          line-height: 22px;
          height: 44px;
          margin-top: 10px;
        }
      }

      .userinfo-box {
        height: 32px;
        margin-top: 8px;

        .name {
          font-size: 14px;
          margin-left: 6px;
        }
      }

      .type {
        height: 32px;
        position: relative;
        margin-left: 18px;
        padding: 5px 18px;

        &::after {
          content: "";
          display: block;
          height: 14px;
          width: 1px;
          background-color: #d8d8d8;
          position: absolute;
          top: 50%;
          margin-top: -7px;
          left: 0;
        }

        span {
          display: inline-block;
          height: 22px;
          background-color: #f0f1f1;
          border-radius: 4px;
          padding: 0 4px;
          color: #868d9f;
          line-height: 22px;
          font-size: 12px;
          margin-right: 6px;
        }
      }

      .dates {
        height: 32px;
        line-height: 32px;

        .date {
          font-size: 14px;
          color: #868d9f;
          position: relative;
          padding-left: 16px;

          &::after {
            content: "";
            display: inline-block;
            height: 12px;
            width: 1px;
            background-color: #d8d8d8;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -6px;
          }
        }

        .comment-list {
          .li {
            color: #868d9f;
            font-size: 14px;
            margin-right: 15px;

            .iconfont {
              margin-right: 5px;
            }

            .text {}
          }
        }
      }
    }

    .article-box {
      border: 1px solid rgb(243, 243, 243);
      border-radius: 7px;
      background: rgb(255, 255, 255);
      padding: 0px 32px 28px;
      margin-top: 26px;
      overflow-x: hidden;
    }

    .article-list {
      width: calc(100% - 340px - 16px);

      .head-box {
        ::v-deep() {
          .el-radio {
            margin-right: 24px;
          }

          .el-radio__label {
            padding-left: 6px;
          }
        }

        .post-article {
          min-width: 93px;
          height: 32px;
          border: 1px solid rgb(183, 37, 30);
          border-radius: 20px;
          padding: 0 16px;
          margin: 0;
          color: #b7251e;
          font-size: 14px;
        }

        .s1 {
          color: rgb(25, 25, 25);
          font-size: 22px;
          font-weight: 400;
          line-height: 24px;
          margin-right: 40px;
          padding-bottom: 7px;
          cursor: pointer;
          transition: all 0.2s;

          &:hover {
            font-family: "MicrosoftYaHeiSemibold";
          }

          &.active {
            font-family: "MicrosoftYaHeiSemibold";
            position: relative;

            &::after {
              content: "";
              display: block;
              width: 28px;
              height: 3px;
              border-radius: 6px;
              background: rgb(168, 51, 40);
              position: absolute;
              bottom: 0;
              left: 50%;
              margin-left: -14px;
            }
          }
        }
      }
    }

    .host-zone {
      width: 340px;
      margin-left: 16px;
    }
  }

  .subject-desc {
    max-width: 1400px;
    margin: 0 auto;
    min-height: 173px;

    .desc-box {
      height: 200px;
      margin-top: 20px;
      border-radius: 8px;
      border: 1px solid rgb(243, 243, 243);
      padding: 36px 0px 26px 32px;
      background-image: url("../../assets/images/subject-desc.png");
      background-size: auto auto;
      background-repeat: no-repeat;
      background-position: left top;

      .descbox {
        height: 138px;

        // 修改滚动条样式
        &::-webkit-scrollbar {
          width: 4px;
          height: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: rgba($color: #b7251e, $alpha: 0.5);
          border-radius: 4px;
        }

        overflow: hidden;
        overflow-y: scroll;
      }

      .title {
        color: rgb(25, 25, 25);
        font-size: 28px;
        font-weight: 400;
        line-height: 28px;
      }

      .desc {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 28px;
        margin-top: 14px;
      }
    }
  }

  .subject-classly {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #efefef;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 20px;
      height: 100%;
      background: linear-gradient(270deg,
          rgba(255, 255, 255, 0.6),
          rgba(255, 255, 255, 0) 100%);
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10;
    }

    .log-imgs {
      position: absolute;
      left: 0;
      top: 0;
    }

    ::v-deep() {
      .swiper-slide {
        width: auto !important;

        .list {
          overflow: hidden;
          // background-size: 66px auto;
          // background-repeat: no-repeat;
          // background-position: left top;
          position: relative;
        }

        // &:nth-child(5n) {
        //   .list::before {
        //     content: "";
        //     display: block;
        //     width: 66px;
        //     height: 68px;
        //     background-image: url("../../assets/images/talk-img5.png");
        //     background-size: auto auto;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //   }

        //   .list.active::before {
        //     background-image: url("../../assets/images/talks-img5.png");
        //   }
        // }

        // &:nth-child(5n-1) {
        //   .list::before {
        //     content: "";
        //     display: block;
        //     width: 66px;
        //     height: 68px;
        //     background-image: url("../../assets/images/talk-img4.png");
        //     background-size: auto auto;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //   }

        //   .list.active::before {
        //     background-image: url("../../assets/images/talks-img4.png");
        //   }
        // }

        // &:nth-child(5n-2) {
        //   .list::before {
        //     content: "";
        //     display: block;
        //     width: 66px;
        //     height: 68px;
        //     background-image: url("../../assets/images/talk-img3.png");
        //     background-size: auto auto;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //   }

        //   .list.active::before {
        //     background-image: url("../../assets/images/talks-img3.png");
        //   }
        // }

        // &:nth-child(5n-3) {
        //   .list::before {
        //     content: "";
        //     display: block;
        //     width: 66px;
        //     height: 68px;
        //     background-image: url("../../assets/images/talk-img2.png");
        //     background-size: auto auto;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //   }

        //   .list.active::before {
        //     background-image: url("../../assets/images/talks-img2.png");
        //   }
        // }

        // &:nth-child(5n-4) {
        //   .list::before {
        //     content: "";
        //     display: block;
        //     width: 66px;
        //     height: 68px;
        //     background-image: url("../../assets/images/talk-img1.png");
        //     background-size: auto auto;
        //     background-repeat: no-repeat;
        //     position: absolute;
        //     left: 0;
        //     top: 0;
        //   }

        //   .list.active::before {
        //     background-image: url("../../assets/images/talks-img1.png");
        //   }
        // }
      }
    }

    .list {
      min-width: 268px;
      height: 68px;
      border: 1px solid rgb(223, 223, 223);
      border-radius: 12px;
      background: rgb(255, 255, 255);
      padding-left: 60px;
      transition: all 0.36s;
      cursor: pointer;
      position: relative;

      .s1 {
        text-align: center;
        color: rgb(51, 51, 51);
        font-size: 20px;
        font-weight: 400;
        line-height: 20px;
        padding: 0 26px;
        position: relative;
        z-index: 10;
      }

      &.active {
        position: relative;
        // background: linear-gradient(180deg,
        //     rgb(230, 93, 87),
        //     rgb(183, 37, 30) 100%);
        background-size: 66px auto;
        background-repeat: no-repeat;
        background-position: left top;
        // background-color: #b7251e;
        z-index: 10;

        &::before {
          content: "";
          display: block;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background: linear-gradient(180deg,
              rgb(230, 93, 87),
              rgb(183, 37, 30) 100%);
        }

        .s1 {
          color: #ffffff;
        }
      }

      &:hover {
        border: 1px solid #b7251e;
      }
    }
  }

  .bread-bar {
    max-width: 1400px;
    margin: 0 auto;
    color: rgb(25, 25, 25);
    font-size: 22px;
    font-weight: 400;
    line-height: 36px;
  }
}

.related-activity {
  margin-top: 28px;
}
</style>